/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

// index.tsx
import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/app/assets/styles/style.css";
import "../src/app/assets/styles/style.css.map";
import "../src/app/assets/styles/style.scss";
import "../src/app/assets/styles/variables.css";
import "../src/app/assets/styles/variables.css.map";
import "../src/app/assets/styles/variables.scss";
import reportWebVitals from "./reportWebVitals";
import { AuthInit, AuthProvider } from "./app/auth";
import AppRoutes from "./app/routings/AppRoutes";   
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import AlertProvider from "./app/component/alert-context/alertContextProvider";
import { SplashScreen } from "./app/features/SplashScreen";
import { requestNotificationPermission,   saveFcmTokenToServer } from "./app/auth/firebase/NotificationService";
import { firebaseConfig } from "./app/auth/firebase/FirebaseConfig";

if ("serviceWorker" in navigator) {
  const swUrl = `${window.location.origin}/firebase-messaging-sw.js`;
  navigator.serviceWorker

    // .register(`${process.env.REACT_APP_WEB_URL}/firebase-messaging-sw.js`)
    .register(`${swUrl}`)
    .then((registration) => {
     
      // Send Firebase config to service worker
      if (registration.active) {
        registration.active.postMessage({
          type: "INIT_FIREBASE",
          firebaseConfig,
        });
      }
      requestNotificationPermission();
      
    const chefData = localStorage.getItem("frayoChefPortal");
let userId = "";

if (chefData) {
  try {
    const parsed = JSON.parse(chefData);
    userId = parsed.uuid || ""; 
  } catch (error) {
    console.error("Error parsing frayoChefPortal:", error);
  }
}

saveFcmTokenToServer({
  userId: userId, 
  userType: "chef",
  appVersion: "1.0.0",
});
    });
}


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

reportWebVitals();

const App: React.FC = () => {
  useEffect(() => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "PLAY_SOUND") {
        
          const audio = new Audio(event.data.soundUrl);
          audio.play().catch((err) => console.error("Audio play error:", err));
        }
      });
    }
  }, []);

  return (
    <Suspense fallback={<SplashScreen />}>
      <AlertProvider>
        <AuthProvider>
          <AuthInit>
            <AppRoutes />
            <ToastContainer />
          </AuthInit>
        </AuthProvider>
      </AlertProvider>
    </Suspense>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
